import { all, fork } from 'redux-saga/effects';
import loginSaga from './LoginSagas';
import portofolioSaga from './PortofolioSagas';
import userPortofolioSaga from './UserPortofolioSagas';
import changePasswordSaga from './ChangePasswordSaga';
import transactionHistorySaga from './TransactionHistorySaga';
import forgotPasswordSaga from './ForgotPasswordSaga';
import marketplaceListSaga from './MarketplaceSaga';
import FundingSaga from './FundingSaga';
import navHeaderSaga from './NavHeaderSaga';
import WithdrawSaga from './WithdrawSaga';
import coorporateProfileSaga from './GetProfileCorporateSaga';
import loanTypeSaga from './LoanTypeSagas';

export default function* rootSaga(): Generator {
	yield all([
		fork(loginSaga),
		fork(portofolioSaga),
		fork(userPortofolioSaga),
		fork(changePasswordSaga),
		fork(transactionHistorySaga),
		fork(forgotPasswordSaga),
		fork(marketplaceListSaga),
		fork(FundingSaga),
		fork(navHeaderSaga),
        fork(WithdrawSaga),
		fork(coorporateProfileSaga),
		fork(loanTypeSaga)
	]);
}
